module.exports = __webpack_public_path__ + "img/banner-robot.fd9c441f.png";